export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND'
export const INCORRECT_PASSWORD = 'INCORRECT_PASSWORD'
export const EMAIL_IN_USE = 'EMAIL_IN_USE'
export const USER_NOT_ACTIVATED = 'USER_NOT_ACTIVATED'
export const UNAUTHORIZED_FOR_THIS_SHOP = 'UNAUTHORIZED_FOR_THIS_SHOP'
